import Header from './Header';
import Footer from './Footer';

const NewLayout = ({ children }) => {
  return (
    <div className="App">
      <Header />
      <main>
        {children}
      </main>
      <Footer />
    </div>
  );
};

export default NewLayout;

